import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Translate } from "react-redux-i18n";
import { updateChatState } from "../../Store/Chat/Actions";

class SupportTile extends Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    onClick(identifier) {
        const { updateChatState } = this.props;

        if (identifier === 3) {
            window.location = "mailto:Insidesales@velocitor.com?Subject=Sales%20Support";
        } else if (identifier === 2) {
            updateChatState(true);
        }
    }

    render() {
        const { image } = this.props;

        return (
            <div className="support-tile rounded flex-column h-100" onClick={() => this.onClick(this.props.identifier)} style={{ cursor: "pointer" }}>
                <img className="mx-auto d-block" src={image} alt="Image Not Found" width="25%" height="25%" />
                <h5 className="text-center">
                    <Translate value={this.props.title} />
                </h5>
                <p className="text-center mx-1 mt-auto">
                    <Translate value={this.props.description} />
                </p>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateChatState: updateChatState
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(SupportTile);